import { useI18n } from '@/hooks/use-i18n';
import { Select } from '@/components/base/select/select';
import { Globe01 } from '@untitledui/icons';
import { useTranslation } from 'react-i18next';

export const LanguageSelector = ({ showLabel = true }: { showLabel?: boolean }) => {
    const { currentLanguage, changeLanguage } = useI18n();
    const { t } = useTranslation('common');

    const languages = [
        { id: 'en', label: 'English' },
        { id: 'it', label: 'Italiano' },
        { id: 'es', label: 'Español' },
    ];

    return (
        <div className="space-y-2">
            {showLabel && <label className="text-sm font-medium text-primary">
                {t('language')}
            </label>}
            <Select
                selectedKey={currentLanguage}
                onSelectionChange={(key) => {
                    if (key && typeof key === 'string') {
                        changeLanguage(key as 'en' | 'it' | 'es');
                    }
                }}
                placeholderIcon={Globe01}
                size="md"
            >
                {languages.map((lang) => (
                    <Select.Item key={lang.id} id={lang.id}>
                        {lang.label}
                    </Select.Item>
                ))}
            </Select>
        </div>
    );
};

